var _DateFormatter_config;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import * as DefaultConfiguration from '../../i18n/en/DateFormatterConfiguration.strings.json';
import TOKEN_TO_STRING_DELEGATES from './TOKEN_TO_STRING_DELEGATES';
export default class DateFormatter {
    constructor(dateFormatterConfiguration = DefaultConfiguration) {
        _DateFormatter_config.set(this, void 0);
        __classPrivateFieldSet(this, _DateFormatter_config, dateFormatterConfiguration, "f");
    }
    format(subject, format) {
        const tokens = Object.keys(TOKEN_TO_STRING_DELEGATES);
        const matcher = /([a-z]+)/ig;
        const result = format.replace(matcher, (token) => {
            if (tokens.indexOf(token) > -1) {
                return TOKEN_TO_STRING_DELEGATES[token](subject, __classPrivateFieldGet(this, _DateFormatter_config, "f"));
            }
            return token;
        });
        return result;
    }
}
_DateFormatter_config = new WeakMap();
